import styled from 'styled-components'

import { ButtonWithTextUnstyled } from 'Components/Buttons/ButtonWithText/unstyled'

export const ButtonWithText = styled(ButtonWithTextUnstyled)`
  display: block;
  height: 44px;
  position: relative;
  cursor: pointer;
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  padding: 0 25px;

  label {
    line-height: 44px;
    margin-bottom: 0;
    cursor: pointer;
    font-family: ${props => props.theme.fonts.robotoRegular};
    font-size: ${props => props.theme.fontSizes.label};
  }
`
